import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { CommonSelect } from './CommonSelect';
import { useSpendTypeOptions } from '../../hooks/useSpendTypeOptions';

export const SpendTypeSelect = ({
  selectedValues,
  onSelect,
  mode,
}: {
  selectedValues: { id: string; name: string }[] | undefined | null;
  onSelect: (values: { id: string; name: string }[] | null) => void;
  mode: 'create' | 'edit';
}) => {
  const spendTypeOptions = useSpendTypeOptions();
  const { t } = useTranslation('global');

  return (
    <CommonSelect
      selectedValues={selectedValues}
      onSelect={onSelect}
      baseOptions={spendTypeOptions}
      placeholder={t('approvalWorkflows.dimensions.spendType.selectASpendType')}
      dimensionName="spendType"
      mode={mode}
    />
  );
};
